export default __webpack_public_path__ + "media/images/elephant_ui_conversation-83162afc12053fe48ad326b35943f4ec.svg";